export const isPhoneOrMailHref = (href: string) => {
  if (href.startsWith('tel:') || href.startsWith('mailto:')) {
    return true;
  }
  return false;
};
